import { Pipe, PipeTransform } from '@angular/core';
import { BusinessCategory, businessCategoryToLabel } from '../types';

@Pipe({
  name: 'businessCategoryToLabel',

})
export class BusinessCategoryToLabelPipe implements PipeTransform {
  transform(businessCategory: BusinessCategory): string {
    return businessCategoryToLabel(businessCategory);
  }
}
